import React, { useState } from "react";
import { Link } from "react-router-dom";

import "./home.css";
import { Button, Card, CardImg, Offcanvas } from 'react-bootstrap';

function Home() {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showDyno, setShowDyno] = useState(false);

    const handleCloseDyno = () => setShowDyno(false);
    const handleShowDyno = () => setShowDyno(true);

    return (
        <>
            <div className="top">
                <div className="d-flex flex-column">
                    <img src={require("../../photo/asco_white_trans.png")} id="logo"></img>
                    <h5>PT. Asco Jaya Huditama</h5>
                </div>
            </div>
            <div className="info">
                <h3 className="mb-4" style={{ color: 'grey' }}>Who are we?</h3>
                    <h4 className="wrw">
                        We are a professional car repair workshop based in Kelapa Gading, North Jakarta, Indonesia. First opened in 1986, we started off as a brand new workshop to serve our community and repair vehicles in Jakarta. Ever since we opened the business, we have thrived in the automotive industry and specialize in repairing cars from all sorts of brands and solve a wide range of problems.
                    </h4>
                    <h4 className="wrw">
                        Over the years we have proven our skills by achieving awards and podiums in domestic and international touring events for over a decade. Our loyal customers has put their trust in us for our professional reputation based on the work we have invested. As a well reputed company, we prioritize giving our customers maximum performance once they have put their trust in us.
                    </h4>
                <Button as={Link} to="/about" style={{ backgroundColor: 'transparent', color: 'grey', border: 0, paddingInline: 0 }}>More about us</Button>
            </div>

            <div className="news-wrapper">
                <div className="news">
                    <img src={require('../../photo/IMG-0292.jpg')} className='news-img'/>
                    <div className="background"></div>
                    <div className="news-text">
                        <h4>Wheel alignment by SetupWizzard</h4>
                        <p className="mt-4 news-subtext">An advanced wheel alignment and corner weighing technology to ensure maximum stability and performance when driving.</p>
                        <Button className="news-button" onClick={handleShow}>See more</Button>
                    </div>
                </div>
                <div className="news">
                    <img src={require('../../photo/IMG-9985.jpg')} className='news-img'/>
                    <div className="background"></div>
                    <div className="news-text">
                        <h4>Dyno</h4>
                        <p className="mt-4 news-subtext">Curious about your horsepower? Curious about your tune up? Hop on and test your speed!</p>
                        <Button className="news-button" onClick={handleShowDyno}>See more</Button>
                    </div>
                </div>
            </div>

            <Offcanvas show={show} onHide={handleClose}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Setupwizzard</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <p>A German based company to introduce a highly accuracate system to measure and adjust the cross weight ratio in a car is now available at Asco. The technology allows us to work efficiently and gain the most precise outcome when adjuting a car's suspension.</p>
                    <p>A laser-based system that shows maximum accuracy at a short period of time.</p>
                </Offcanvas.Body>
            </Offcanvas>

            <Offcanvas show={showDyno} onHide={handleCloseDyno}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Dyno</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <p>Our dyno machine is a device that allows cars to run with or without tuning (remap) which measures the precise value of power and torque generated. This is the best tool to achieve the best tuning while running and allows efficiency during the process.</p>
                    <p>After every run customers are able to see the exact number of horsepower (HP) and Torque followed by a graph to show the peak and increase of power at a certain RPM.</p> 
                </Offcanvas.Body>
            </Offcanvas>

            <div className="insta">
                <a href="https://www.instagram.com/jaysonadam/">
                    <img src={require('../../photo/instagram.png')} className='social'></img>
                </a>
                <h3>Follow us on Instagram to see more</h3>
                <Button href='https://www.instagram.com/ascomotortuning/' variant="light" className="insta-button">ascomotortuning</Button>
            </div>

            <div className="home mb-5">
                <a href='/services' className="link">
                    <Card className="card-home">
                        <CardImg src={require('../../photo/IMG-0498.jpg')}/>
                        <Card.ImgOverlay>
                            <Card.Title>Services</Card.Title>
                        </Card.ImgOverlay>
                    </Card>
                </a>
                <a href='/about' className="link">
                    <Card className="card-home">
                        <CardImg src={require('../../photo/Asco Logo (small).jpg')}/>
                        <Card.ImgOverlay>
                            <Card.Title>About</Card.Title>
                        </Card.ImgOverlay>
                    </Card>
                </a>
                <a href='/achievements' className="link">
                    <Card className="card-home">
                        <CardImg src={require('../../photo/TGR(BIG).jpg')}/>
                        <Card.ImgOverlay>
                            <Card.Title>Achievements</Card.Title>
                        </Card.ImgOverlay>
                    </Card>
                </a>
                <a href='/gallery' className="link">
                    <Card className="card-home">
                        <CardImg src={require('../../photo/IMG-0051.jpg')}/>
                        <Card.ImgOverlay>
                            <Card.Title>Gallery</Card.Title>
                        </Card.ImgOverlay>
                    </Card>
                </a>
            </div>

        </>
    )
};

export default Home;